export type NormalizedPlanSlug = 'hobby' | 'basic' | 'pro' | 'enterprise';

const PLAN_ALIAS_MAP: Record<string, NormalizedPlanSlug> = {
  free: 'hobby',
  hobby: 'hobby',
  basic: 'basic',
  pro: 'pro',
  enterprise: 'enterprise',
  custom: 'enterprise',
};

const PLAN_INCLUDED_UNIT_OVERRIDES: Partial<Record<NormalizedPlanSlug, number>> = {
  hobby: 100,
  basic: 5000,
  pro: 50000,
};

export function normalizePlanSlug(plan?: string | null): NormalizedPlanSlug | null {
  if (!plan) {
    return null;
  }
  const normalized = plan.trim().toLowerCase();
  return PLAN_ALIAS_MAP[normalized] ?? null;
}

export function getPlanIncludedUnits(plan?: string | null): number | null {
  const normalized = normalizePlanSlug(plan);
  if (!normalized) {
    return null;
  }
  return PLAN_INCLUDED_UNIT_OVERRIDES[normalized] ?? null;
}
